import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetAvgDaysToResolveRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetAvgDaysToResolveResponseDtoSchema = z.object({
  changePct: z.number().nullable(),
  count: z.number(),
  sparkline: z
    .object({
      granularity: z.enum(['day', 'week', 'month']),
      points: z.array(SparkLinePointDtoSchema),
    })
    .optional(),
});

export type GetAvgDaysToResolveRequestDto = z.infer<
  typeof _GetAvgDaysToResolveRequestDtoSchema
>;
export type GetAvgDaysToResolveResponseDto = z.infer<
  typeof GetAvgDaysToResolveResponseDtoSchema
>;

export const getAvgDaysToResolveKpi = (
  params: GetAvgDaysToResolveRequestDto,
  config?: AxiosRequestConfig<GetAvgDaysToResolveRequestDto>
) =>
  api
    .get('alerts/dashboard/avg-days-to-resolve', { params, ...config })
    .then(responseContract(GetAvgDaysToResolveResponseDtoSchema));
